export default function LeaveIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={18}
        height={18}
        x={0}
        y={0}
        viewBox="0 0 32 32"
        // style={{ enableBackground: 'new 0 0 512 512' }}
        xmlSpace="preserve"
        className=""
      >
        <g>
          <path
            d="M30.5 31h-15a.5.5 0 0 1 0-1H30V2H15a.5.5 0 0 1 0-1h15.5a.5.5 0 0 1 .5.5v29a.5.5 0 0 1-.5.5zM3.785 31a.5.5 0 0 1-.484-.63l2.748-10.188a.5.5 0 1 1 .966.259L4.267 30.63a.499.499 0 0 1-.482.37zM11 7C9.346 7 8 5.654 8 4s1.346-3 3-3 3 1.346 3 3-1.345 3-3 3zm0-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.896-2-2-2zM9.046 20.171 5.432 30.336a.5.5 0 0 0 .942.336l3.443-9.683z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
          <path
            d="M13.568 31.004a.5.5 0 0 1-.49-.403l-1.211-6.153a2.5 2.5 0 0 0-.632-1.223l-3.699-3.928a3.51 3.51 0 0 1-.945-2.64l.36-5.23-2.169.677-.821 3.204c-.169.767-.969 1.294-1.782 1.125a1.505 1.505 0 0 1-1.144-1.79l1.003-3.981a1.5 1.5 0 0 1 .855-1.032l4.505-2.004c.229-.102.481-.145.73-.121l4.44.402a3.5 3.5 0 0 1 2.538 1.458l1.921 2.703 3.035-.362c.38-.064.776.037 1.099.276.322.237.533.586.594.982.061.395-.036.79-.273 1.113s-.587.534-.983.595l-3.75.692a1.487 1.487 0 0 1-1.351-.432l-1.107-1.145a.5.5 0 1 1 .719-.695l1.107 1.145a.495.495 0 0 0 .449.145l3.767-.695c.148-.023.265-.094.344-.201s.111-.239.091-.37a.505.505 0 0 0-.198-.329.51.51 0 0 0-.371-.091l-3.346.4a.486.486 0 0 1-.467-.206l-2.093-2.945a2.493 2.493 0 0 0-1.812-1.042l-4.442-.402a.501.501 0 0 0-.235.039l-4.507 2.004a.498.498 0 0 0-.286.349l-1.003 3.979a.5.5 0 0 0 .384.583.515.515 0 0 0 .596-.38l.895-3.49a.502.502 0 0 1 .335-.354l3.133-.978a.505.505 0 0 1 .459.085c.129.103.2.262.189.427l-.41 5.96a2.506 2.506 0 0 0 .674 1.886l3.7 3.928c.45.478.756 1.07.885 1.713l1.211 6.155a.5.5 0 0 1-.491.597z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
          <path
            d="M15.583 31.004a.5.5 0 0 1-.498-.465l-.504-7.125a2.5 2.5 0 0 0-.289-1.002l-2.232-4.177a.5.5 0 0 1-.058-.268l.471-7.224a.488.488 0 0 1 .532-.467.5.5 0 0 1 .466.531l-.462 7.082 2.165 4.051c.233.437.37.908.404 1.402l.504 7.125a.5.5 0 0 1-.463.534c-.012.003-.024.003-.036.003zM26.5 6h-9a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
          <path
            d="M24.5 8a.5.5 0 0 1-.354-.853L25.793 5.5l-1.646-1.646a.5.5 0 0 1 .707-.707l2 2a.5.5 0 0 1 0 .707l-2 2A.502.502 0 0 1 24.5 8zM26.5 17c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2a.5.5 0 1 0 .002 1.002A.5.5 0 0 0 26.5 15z"
            fill="#000000"
            opacity={1}
            data-original="#000000"
            className=""
          />
        </g>
      </svg>
    </>
  );
}
